import { render, staticRenderFns } from "./PieByGender.vue?vue&type=template&id=d29e475e&scoped=true&"
import script from "./PieByGender.vue?vue&type=script&lang=js&"
export * from "./PieByGender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d29e475e",
  null
  
)

export default component.exports